import { render, staticRenderFns } from "./ValidationTextField.vue?vue&type=template&id=b875907a&scoped=true"
import script from "./ValidationTextField.vue?vue&type=script&lang=ts"
export * from "./ValidationTextField.vue?vue&type=script&lang=ts"
import style0 from "./ValidationTextField.vue?vue&type=style&index=0&id=b875907a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b875907a",
  null
  
)

export default component.exports